import { GridView } from '@vivli/shared/views';
import { GridApi } from 'ag-grid-community';
import { IDataRequestSummary } from '@vivli/features/data-requests/infrastructure/interface';
import { dataRequestGridCustomComponents, DataRequestsGridDisplayType, useDataRequestGridColumns } from './data-requests-grid-columns.hook';

interface DataRequestsGridComponentProps {
    dataRequests: IDataRequestSummary[];
    onRowClick?: (dataRequest: IDataRequestSummary) => void;
    onGridReady?: (gridApi: GridApi) => void;
    emptyMessage?: string;
    hideFloatingFilter?: boolean;
    autoHeight?: boolean;
    displayType?: DataRequestsGridDisplayType;
    isPresumedResearcher?: boolean; //we don't have myrequests page type any more, lets us set certain properties
    // originally tied to page type
    onRowCountChange?: (count: number) => void;
    initialSortField?: string;
    initialSortOrder?: 'asc' | 'desc';
}

export const DataRequestsGridComponent = ({
    dataRequests,
    onRowClick,
    onGridReady,
    emptyMessage,
    hideFloatingFilter,
    autoHeight,
    displayType,
    onRowCountChange,
    isPresumedResearcher,
    initialSortField,
    initialSortOrder
}: DataRequestsGridComponentProps) => {
    const handleRowClick = (dataRequest: IDataRequestSummary) => {
        onRowClick && onRowClick(dataRequest);
    };

    const columns = useDataRequestGridColumns({ displayType, isPresumedResearcher, initialSortField, initialSortOrder });

    return (
        <GridView
            rowData={dataRequests}
            columns={columns}
            hideHeader={true}
            hideFloatingFilter={hideFloatingFilter}
            fullWidthColumns={true}
            customComponents={dataRequestGridCustomComponents}
            rowHeight={displayType === 'myrequests' ? 120 : 95}
            onRowClick={handleRowClick}
            onGridReady={onGridReady}
            emptyMessage={emptyMessage}
            autoHeight={autoHeight}
            onRowCountChange={onRowCountChange}
        />
    );
};
